import apiClient from '../api/apiClient';

export interface ProfilePhotoUploadResponse {
  url: string;
  message: string;
}

export interface ProfilePhotoDeleteResponse {
  message: string;
}

export const uploadProfilePhoto = async (
  file: File
): Promise<ProfilePhotoUploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post<ProfilePhotoUploadResponse>(
    '/profilephotos',
    formData,
    {
      headers: {
        'Content-Type': undefined as any,
      },
    }
  );

  return response.data;
};

export const replaceProfilePhoto = async (
  userId: string,
  file: File
): Promise<ProfilePhotoUploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('user_id', userId);

  const response = await apiClient.put<ProfilePhotoUploadResponse>(
    '/profilephotos',
    formData,
    {
      headers: {
        'Content-Type': undefined as any,
      },
    }
  );

  return response.data;
};

export const deleteProfilePhoto = async (
  userId: string
): Promise<ProfilePhotoDeleteResponse> => {
  const response = await apiClient.delete<ProfilePhotoDeleteResponse>(
    `/profilephotos/${userId}`
  );

  return response.data;
};
